module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view-toggle"
  }, [_c('div', {
    staticClass: "options"
  }, [_c('div', {
    staticClass: "option drift",
    class: {
      'selected': _vm.$store.state.view === 'operations'
    },
    on: {
      "click": function($event) {
        return _vm.doToggle('operations', _vm.operationsLink)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.operationsName) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "option udvikling",
    class: {
      'selected': _vm.$store.state.view === 'learning'
    },
    on: {
      "click": function($event) {
        return _vm.doToggle('learning', _vm.learningLink)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.learningName) + "\n        ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77c8f022"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/viewToggle.vue
// module id = 904
// module chunks = 0